import React from 'react';
import styled from 'styled-components';
import { object, string } from 'prop-types';
import { has, assoc, prop, dissoc, pipe } from 'ramda';
import ReactMarkdown from 'react-markdown';
import { format, currency } from '@olxbr/mojo-jojo/utils/string';
import OrangeButton from '../core/components/OrangeButton';

const Button = styled(OrangeButton)`
  @media (max-width: 1000px) {
    display: block;
  }

  del {
    color: #fad0ac;
  }
`;

const createPrice = value => pipe(
  assoc('previousPrice', `~~${currency(prop('previous', value))}~~`),
  assoc('price', prop('current', value)),
  dissoc('previous'),
  dissoc('current'),
)(value);

const CheckoutButton = ({
  product, url, label, ...props
}) => {
  const { totalPrice } = product;
  const price = has('previous', totalPrice) ? createPrice(totalPrice) : assoc('price', totalPrice, {});

  return (
    <Button href={url} {...props}>
      <ReactMarkdown source={format(label, price)} />
    </Button>
  );
};

CheckoutButton.propTypes = {
  product: object.isRequired,
  label: string.isRequired,
  url: string,
};

CheckoutButton.defaultProps = {
  url: '',
};

export default CheckoutButton;
